import FastOrder from "../FastOrder";

export default class WholesaleRequestPopup {
    static init() {
        $('.js-show-wholesale-request').off('click.WholesaleRequestPopup').on('click.WholesaleRequestPopup', (e) => {
            e.preventDefault();
            new WholesaleRequestPopup();
        });

        $(window).off('ContentConcealer:ready').on('ContentConcealer:ready', this.init.bind(this));
    }

    constructor(data) {
        this.data = data;
        this.state = 'fill';
        this.prefix = 'wholesale-request';

        this.$popup = $(this.popupTemplate());
        $('body').append(this.$popup);

        this.$popup.modal('show');

        this.$popup.find(`.${this.prefix}-agreement`).on('change', this.toggleSubmit.bind(this));
        this.$popup.find(`.${this.prefix}-modal__submit`).on('click', this.onSubmit.bind(this));
        this.$popup.on('hidden.bs.modal', this.onClose.bind(this));
    }

    popupTemplate() {
        return `
            <div class="modal fade simple-modal ${this.prefix}-modal" id="${this.prefix}-modal" tabindex="-1" role="dialog"  aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="close simple-modal__close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <div class="simple-modal__title">Заявка</div>
                            <div class="simple-modal__subtitle">
                                Оставьте свои данные и наш менеджер свяжется с вами для предоставления доступа к оптовым ценам
                            </div>

                            <div class="${this.prefix}-modal__form">
                                <input type="hidden" name="_key" value="qp37rp5tOgDQq" />
                                <div class="form-group">
                                    <input type="text"
                                        class="lb-input ${this.prefix}-modal__input ${this.prefix}-modal__input--name"
                                        placeholder="Ваше ФИО"
                                         required
                                     />
                                </div>
                                <div class="form-group">
                                    <input type="text"
                                        class="${this.prefix}-modal__input ${this.prefix}-modal__input--phone lb-input"
                                        placeholder="Ваш номер телефона"
                                        required
                                    />
                                </div>
                                <div class="form-group">
                                    <input type="text"
                                        class="${this.prefix}-modal__input ${this.prefix}-modal__input--email lb-input"
                                        placeholder="Ваш E-mail"
                                        required
                                    />
                                </div>
                                
                                <div class="form-group">
                                    <input type="checkbox" class="${this.prefix}-agreement" id="${this.prefix}-agreement" />
                                    <label class="mr-1" for="${this.prefix}-agreement">Я даю согласие на обработку персональных данных</label>
                                </div>
                                
                                <div class="${this.prefix}-modal__success hidden">Спасибо, мы скоро с вами свяжемся</div>
                            </div>

                            <div>
                                <div class="${this.prefix}-modal__btn-block">
                                    <button class="gui-button gui-button--disabled ${this.prefix}-modal__submit" disabled>Отправить</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    onSubmit() {
        switch (this.state) {
            case 'sent':
                this.$popup.modal('hide');
                //this.$popup.remove();
                //delete this;

                break;

            case 'fill':
            default:
                const name = this.$popup.find(`.${this.prefix}-modal__input--name`).val();
                const phone = this.$popup.find(`.${this.prefix}-modal__input--phone`).val();
                const email = this.$popup.find(`.${this.prefix}-modal__input--email`).val();

                if (name == '' || phone == '' || email == '') {
                    alert('Заполните поля');
                    return;
                }

                $.ajax({
                    url: '/local/public/wholesale_request.php',
                    dataType: 'json',
                    method: 'post',
                    data: {
                        name,
                        phone,
                        email,
                        ajax: 'Y',
                        formId: 'wholesale_request',
                        _protect: this.$popup.find('input[name="_key"]').val().substr(3),
                        sessid: app.sessid
                    }
                }).done((response) => {
                    if (response.status == 'error') {
                        let errors = '';

                        if (response.error) {
                            errors = response.error;
                        } else {
                            for (var i = 0; i < response.errors.length; i++) {
                                errors += response.errors[i].text + '\n';
                            }
                        }

                        alert(errors);
                        return;
                    }

                    this.$popup.find(`.${this.prefix}-modal__success`).removeClass('hidden');
                    this.$popup.find(`.${this.prefix}-modal__submit`).text('Закрыть');
                    this.state = 'sent';
                });

                break;
        }
    }

    onClose() {
        this.$popup.modal('dispose');
        delete this;
    }

    toggleSubmit(e) {
        const $button = this.$popup.find(`.${this.prefix}-modal__submit`);
        $button.prop('disabled', !$(e.currentTarget).prop('checked'));
        $button.toggleClass('gui-button--disabled', !$(e.currentTarget).prop('checked'));
    }
}